export const MODE = {
    WHITELIST: "whitelist",
    BLACKLIST: "blacklist",
};
